import React from 'react';
import Icon from '../Icon';
import { tie } from '../page/typography';
import { bodyText } from './prose';

/**
 * Врізка «ризик» — єдине жовте місце в статті.
 *
 * Жовтий тут стоїть над тим, що справді загрожує ліцензії, а не над усім
 * вступом, як раніше. Перший абзац — пряма відповідь на питання заголовка,
 * тому він щільніший за другий, де розписано механізм.
 *
 * Іконка — лише від sm: на телефоні вона стояла б окремим рядком над
 * текстом, а колір рамки й підпис «Ризик» над заголовком і так кажуть, що
 * це за блок.
 */
const RiskNote = ({ paragraphs = [], className = '' }) => (
  <div className={`rounded-2xl border border-amber-200 bg-amber-50/60 p-5 sm:p-7 flex gap-5 ${className}`}>
    <span
      className="hidden sm:flex flex-shrink-0 w-11 h-11 rounded-xl border border-amber-200 bg-white text-amber-600 items-center justify-center"
      aria-hidden="true"
    >
      <Icon name="fa-exclamation-triangle" className="text-lg" />
    </span>
    <div className="min-w-0 space-y-4">
      {paragraphs.map((paragraph, i) => (
        <p key={paragraph.slice(0, 40)} className={`${bodyText} ${i === 0 ? 'font-medium text-slate-900' : 'text-slate-800'}`}>
          {tie(paragraph)}
        </p>
      ))}
    </div>
  </div>
);

export default RiskNote;
